import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mailT",
  "use": "icon-mailT-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 400 400\" id=\"icon-mailT\">\n<style type=\"text/css\">\n\t#icon-mailT .st0{fill:#005FAF;}\n</style>\n<g id=\"icon-mailT_mail.psd\">\n\t<g id=\"icon-mailT__x2D_s-admin_icon\">\n\t\t<path class=\"st0\" d=\"M321,91c16.5,0,30,13.5,30,30v150c0,16.5-13.5,30-30,30H81c-16.5,0-30-13.5-30-30V121c0-16.5,13.5-30,30-30\n\t\t\tH321 M321,61H81c-33.1,0-60,26.9-60,60v150c0,33.1,26.9,60,60,60h240c33.1,0,60-26.9,60-60V121C381,87.9,354.1,61,321,61L321,61z\" />\n\t\t<path class=\"st0\" d=\"M198.8,237.6c-9.1,0-18.2-2.6-26.1-7.9l-145-96.3l16.6-25l145,96.3c5.7,3.8,13.2,3.9,18.9,0.1l149.7-96.5\n\t\t\tl16.3,25.2l-149.7,96.5C216.6,235.1,207.7,237.6,198.8,237.6z\" />\n\t</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/mailT.svg
// module id = RvZf
// module chunks = 35